import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const CardWrapper = styled.div<{ $unavailable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
  padding: ${space[4]};
  background: ${({ $unavailable }) => ($unavailable ? semantic.bg.surfaceStrong : colors.white)};
  border: 1px solid ${semantic.border.subtle};
  border-radius: ${layout.borderRadiusLg};
  opacity: ${({ $unavailable }) => ($unavailable ? 0.7 : 1)};

  @media (max-width: ${layout.desktopBreakpoint}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${space[3]};
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  min-width: 0;
  flex: 1;
`;

export const Thumbnail = styled.div`
  width: 48px;
  height: 48px;
  border-radius: ${layout.borderRadiusMd};
  overflow: hidden;
  flex-shrink: 0;
  background: ${semantic.bg.surfaceSubtle};
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${semantic.bg.surfaceStrong};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Name = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  line-height: 1.3;
`;

export const UnavailableTextWrapper = styled.div`
  background: ${colors.white};
  padding: ${space[2]} ${space[3]};
  border-radius: ${layout.borderRadiusXl};
  display: grid;
  grid-template-columns: auto auto;
  gap: ${space[2]};
`;

export const Label = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: 1.4;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[4]};
  flex-shrink: 0;
`;

export const SelectButton = styled.button`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  background: ${semantic.text.primary};
  color: ${colors.white};
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }
`;

export const UnavailableText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const PriceWrapper = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;
